import {
    addToCart,
    createCart,
    getCart,
    removeFromCart,
    updateCart
} from 'lib/burokshop';

export async function addItem(selectedVariantId: string | undefined) {
  if (!selectedVariantId) {
    return { error: 'Error adding item to cart' };
  }

  try {
    const cart = await addToCart([{ merchandiseId: selectedVariantId, quantity: 1 }]);
    return { success: true, cart };
  } catch (e) {
    console.error(e);
    return { error: 'Error adding item to cart' };
  }
}

export async function removeItem(merchandiseId: string) {
  try {
    const cart = await getCart();

    if (!cart) {
      return { error: 'Error fetching cart' };
    }

    const lineItem = cart.lines.find(
      (line) => line.merchandise.id === merchandiseId
    );

    if (lineItem && lineItem.id) {
      const updatedCart = await removeFromCart([lineItem.id]);
      return { success: true, cart: updatedCart };
    } else {
      return { error: 'Item not found in cart' };
    }
  } catch (e) {
    console.error(e);
    return { error: 'Error removing item from cart' };
  }
}

export async function updateItemQuantity(payload: {
    merchandiseId: string;
    quantity: number;
}) {
  const { merchandiseId, quantity } = payload;

  try {
    const cart = await getCart();

    if (!cart) {
      return { error: 'Error fetching cart' };
    }

    const lineItem = cart.lines.find(
      (line) => line.merchandise.id === merchandiseId
    );

    if (lineItem && lineItem.id) {
      if (quantity === 0) {
        const updatedCart = await removeFromCart([lineItem.id]);
        return { success: true, cart: updatedCart };
      } else {
        const updatedCart = await updateCart([
          {
            id: lineItem.id,
            merchandiseId,
            quantity
          }
        ]);
        return { success: true, cart: updatedCart };
      }
    } else if (quantity > 0) {
      const updatedCart = await addToCart([{ merchandiseId, quantity }]);
      return { success: true, cart: updatedCart };
    }

    return { success: true, cart };
  } catch (e) {
    console.error(e);
    return { error: 'Error updating item quantity' };
  }
}

export async function createCartAndSetCookie() {
  try {
    const cart = await createCart();
    return { success: true, cart };
  } catch (e) {
    console.error(e);
    return { error: 'Error creating cart' };
  }
}
